let quizSection = document.querySelectorAll(".quiz-frame")

if(quizSection.length){
  quizSection.forEach((section)=>{
       let quiz = section.querySelectorAll(".quiz-question-block");
    let nextBtns = section.querySelectorAll(".btn button");
    let currentQuiz = section.querySelector(".active-quiz");


    if (quiz.length) {
      quiz.forEach((q, indx) => {
        let correctAns = q.querySelector(".correct-answer input").value;
        let desc = q.querySelector(".description");
        let options = q.querySelectorAll("li.quiz-option");
        let nxtQuizBtn = section.querySelectorAll(".btn")[indx];
        let clicked = false;
        let data_question__title = q.innerText
        if (indx === 0) {
          q.classList.remove("hide");
          q.setAttribute("tabindex", "-1");
        //   q.focus();
        }

        options.forEach((op, i) => {
          op.addEventListener("click", () => {
            if (clicked) return;
            clicked = true;

            op.setAttribute("aria-checked", "true");
            if (i === parseInt(correctAns) - 1) {
              op.classList.add("right-tick");
              op.setAttribute("aria-label", op.textContent + ", correct answer");
            } else {
              op.classList.add("wrong");
              op.setAttribute("aria-label", op.textContent + ", wrong answer");
            }
            options[parseInt(correctAns) - 1].classList.add("right-tick");
            if(desc){
                desc.classList.remove("h-0");
            }
            if ((quiz.length > 1) && (indx < quiz.length - 1)) {
              nxtQuizBtn.classList.remove("hide");
              nxtQuizBtn.setAttribute("tabindex", "0");
              nxtQuizBtn.focus();
            }
            
            let quiz_option_text = op.innerText
            const currentUrl = window.location.href;
            let quizQuestion =  q.querySelector(".quiz-question h4").getAttribute("data-question-id").replaceAll("_"," ");
            dataLayer.push({
              event: 'quiz',
              quiz_question: quizQuestion,
              quiz_option: quiz_option_text,
              page_path: currentUrl
            });

            // --- NEW: AJAX POST to endpoint ---
            const quizId = q.getAttribute("data-quiz-id");         
              const questionId = q.getAttribute("data-question-id");
                fetch('/api/quiz-response', {
                  method: 'POST',
                  body: JSON.stringify({
                    quiz_id: quizId,
                    question_id: questionId,
                    selected_option: i
                  }),
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                .then(res => res.json())
                .then(data => {
                  if (data.percentages) {
                                  options.forEach((opt, idx) => {
                    opt.style.background = '';          
                    opt.style.position = 'relative';    
                    
                    const percentSpan = opt.querySelector('.option-percent');
                    if (percentSpan) { percentSpan.remove(); }

                    const found = data.percentages.find(p => p.optionIndex === idx);
                    if (found) {
                      const percent = found.percent;
                      opt.style.background = `linear-gradient(to right, rgba(152, 0, 46, 0.1) ${percent}%, transparent ${percent}%)`;

                      const span = document.createElement('span');
                      span.className = 'option-percent';
                      span.textContent = `${percent}%`;

                      span.style.position = 'absolute';
                      span.style.right = '10px';     
                      span.style.top = '50%';
                      span.style.transform = 'translateY(-50%)';
                      span.style.color = '#98002E';    
                      span.style.fontWeight = '600';
                      span.style.fontSize = '12px';
                      span.style.whiteSpace = 'nowrap';
                      span.style.userSelect = 'none';
                      span.style.pointerEvents = 'none';

                      opt.appendChild(span);
                    }
                  });

                  }
                });
                // --- END AJAX ---


          });

          op.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              op.click();
            }
          });
        });
      });

      nextBtns.forEach((btn, i) => {
        btn.addEventListener("click", () => {
          btn.classList.add("hide");
          quiz[i].classList.add("hide");
          quiz[i + 1].classList.remove("hide");
          quiz[i + 1].focus();
          let currentQuizVal = currentQuiz.getAttribute("value")
          currentQuiz.innerHTML = parseInt(currentQuizVal)+1
          currentQuiz.setAttribute("value",(parseInt(currentQuizVal)+1))
        });
      });
    }
  })

}




// const questionText = q.querySelector("h4")?.innerText || "";
//         const optionText = op.innerText.trim();
//         const isCorrect = i === parseInt(correctAns) - 1;
//         // 🔴 GA4 Event Tracking
//         gtag('event', 'quiz_option_click', {
//             event_category: 'Quiz',
//             event_label: `${questionText} - ${optionText}`,
//             value: isCorrect ? 1 : 0,
//             question_text: questionText,
//             option_text: optionText,
//             is_correct: isCorrect,
//             question_index: indx + 1
//         });
